import cn from 'classnames';
import type { PlatformCompany } from '../../../../types';
import type { CompanyRowDisplayFlags } from '../types';
import { HeaderBlock, CertBlock, ProductBlock, TagsBlock } from '../row-blocks';

export interface MadeInChinaCompanyCardProps {
  company: PlatformCompany;
  displayFlags: CompanyRowDisplayFlags;
  className?: string;
}

/**
 * MadeInChinaCompanyCard — 中国制造（MADE_IN_CHINA）供应商卡片
 *
 * 结构与 AliIntlCompanyCard 相同（price 变体）；
 * 独立拆分便于后续按平台定制样式或字段。
 */
export function MadeInChinaCompanyCard({ company, displayFlags, className }: MadeInChinaCompanyCardProps) {
  const { showCertSection, showProductSection, showTagsSection } = displayFlags;

  return (
    <div className={cn('bg-white rounded-lg p-3 h-full', className)}>
      {/* 区块1：头部 */}
      <HeaderBlock company={company} />

      {/* 区块2：认证标签行 */}
      <CertBlock show={showCertSection} certList={company.certList} />

      {/* 区块3：产品信息 */}
      <ProductBlock show={showProductSection} company={company} />

      {/* 水平分隔线 */}
      {showProductSection && showTagsSection && <div className="border-t border-[#F0F0F0]" />}

      {/* 区块4：显示商品标签 */}
      <TagsBlock show={showTagsSection} tagList={company.mainProducts} />
    </div>
  );
}
